export enum MessageChannelCategory {
  Camp = 'camp',
  Period = 'period',
  Region = 'region',
}

export const messageChannelCategoryLabels: Record<
  MessageChannelCategory,
  string
> = {
  [MessageChannelCategory.Camp]: $localize`:@@messageChannelCategoryCamp:Camp`,
  [MessageChannelCategory.Period]: $localize`:@@messageChannelCategoryPeriod:Period`,
  [MessageChannelCategory.Region]: $localize`:@@messageChannelCategoryRegion:Region`,
};
